import React from 'react';
import { useLocation } from 'react-router-dom';
import UserManagement from '../features/userSettings/components/UserManagement';
import CustomerGroupManagement from '../features/customerGroupManagement/CustomerGroupManagement';

const AdministrationPage = () => {
  const { pathname } = useLocation();

  const title = pathname === '/administration/pool-management'
    ? 'Customer & Pool Management'
    : 'User Management';

  const renderContent = () => {
    if (pathname === '/administration/pool-management') return <CustomerGroupManagement />;
    return <UserManagement />;
  };

  return (
    <div className="h-full flex flex-col bg-gray-100">
      <div className="flex-none bg-gray-100 px-6 shadow-sm z-20">
        <div className="pt-4 pb-3 border-b border-gray-300">
          <h1 className="text-2xl font-bold text-primary">{title}</h1>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto bg-gray-50 p-6">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdministrationPage;
